import { IPreloadedState } from 'shared/types/redux';

export const selectJsonQuery = (state: IPreloadedState) => state.offers.data.jsonQuery;
